<template>
  <div class="inisde-tab">
    <a href="" >上一页</a>
    <a href="" class="page-num-current">1</a>
    <a href="" class="">下一页</a>
  </div>
</template>

<script setup>

</script>


<style scoped>
.inisde-tab {
  padding: 0px 0 10px 0;
  text-align: center
}
.inisde-tab a {
  line-height: 30px;
  margin-right: 3px;
  padding: 0 10px;
  color: #999898;
  font-family: arial;
  display: inline-block;
  border: solid 1px #dcdcdc;
  text-decoration: none;
}
.inisde-tab a:hover, .inisde-tab .page-num-current {
  color: #fff;
  border-color: #ef801a;
  background: #ef801a
}
</style>